export default "__VITE_ASSET__CBJtqZz___"